import { render, staticRenderFns } from "./ManageCommentGroups.vue?vue&type=template&id=b6a71cd0"
import script from "./ManageCommentGroups.vue?vue&type=script&lang=js"
export * from "./ManageCommentGroups.vue?vue&type=script&lang=js"
import style0 from "./ManageCommentGroups.vue?vue&type=style&index=0&id=b6a71cd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
